import React from "react";
import WebpResizerFaq from "./WebpResizerFaq";
import WebpResizerUseCase from "./WebpResizerUseCase";
import { WebpResizeByDimensions } from "./WebpResizeByDimension";

const WebpResizerPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <WebpResizeByDimensions />
                <WebpResizerUseCase />
                <WebpResizerFaq />
            </div>
        </div>
    );
};

export default WebpResizerPreToolsArea;
